import { useNavigate } from 'react-router-dom'
import { unitId, actionId } from '@/annotations'
import { LauncherCard } from '@/components/LauncherCard'

/**
 * `v-jobs` — process/09-SCREEN-SPECS/v-jobs.md, Prototype_v2.html `#v-jobs` (`div.grid3`, two
 * `card g-teal`). **Rebuilt W174**: the previous shape was a bare bordered list item with a
 * trailing chevron for each of the two cards, colourless and without the icon or description text
 * the prototype's own markup carries for both.
 */
export function VJobs() {
  const navigate = useNavigate()
  return (
    <div data-scr={unitId('v-jobs')}>
      <h1 className="m-0 mb-8 text-section font-semibold">Backup jobs</h1>
      <div className="grid gap-8" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(330px, 1fr))' }}>
        <LauncherCard
          variant="teal"
          icon="i-backup"
          title="Backup Jobs"
          description="Monitor and manage all your backup operations, viewing their real-time status, detailed history, and execution logs."
          actionId={actionId('nav.v-jobsbackup')}
          onClick={() => navigate('/jobs/backup')}
        />
        <LauncherCard
          variant="teal"
          icon="i-restore"
          title="Restore Jobs"
          description="Track the progress and outcome of all your data recovery operations and view detailed logs for process validation."
          actionId={actionId('nav.v-jobsrestore')}
          onClick={() => navigate('/jobs/restore')}
        />
      </div>
    </div>
  )
}
